import type { MinifiedTask } from '@gcv/shared';
import { TaskStatus } from '@gcv/shared';

export const getGroupedStatus = (tasks: MinifiedTask[]): TaskStatus => {
  const statuses = tasks.map((task) => task.status);

  if (statuses.includes(TaskStatus.PROCESSING)) {
    return TaskStatus.PROCESSING;
  } else if (statuses.includes(TaskStatus.OPEN) && statuses.includes(TaskStatus.COMPLETE)) {
    return TaskStatus.PROCESSING;
  } else if (statuses.includes(TaskStatus.COMPLETE)) {
    return TaskStatus.COMPLETE;
  } else if (statuses.every((status) => status === TaskStatus.SUPPRESSED)) {
    return TaskStatus.SUPPRESSED;
  } else {
    return TaskStatus.OPEN;
  }
};
